import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    body: `"Roboto", sans-serif`,
  },
});

export default theme;
